export default [{
  name: 'magalupay',
  namespaced: true,
  state: {
    model: {
      endereco: {},
      ticket: {}
    },
    enderecos: [],
    dadosIniciais: {},
    bottomSheetTermos: false,
    bottomSheetParcelas: false,
    simulacaoVencimento: false,
    simulacaoParcelas: false,
    skipIntro: 3,
    searchCEP: false,
    actualState: 0
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    enderecos (state, obj) {
      state.enderecos = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    },
    bottomSheetTermos (state, { value, router }) {
      if (router) { value ? router.altPush('/detalhes-proposta?bottom=termos') : router.altPush('/detalhes-proposta') }
      state.bottomSheetTermos = value
    },
    bottomSheetParcelas (state, { value, router }) {
      if (router) { value ? router.altPush('/detalhes-proposta?bottom=parcelas') : router.altPush('/detalhes-proposta') }
      state.bottomSheetParcelas = value
    },
    simulacaoVencimento (state, { value, router }) {
      if (router) { value ? router.altPush('/simulacao?modal=vencimento') : router.altPush('/simulacao') }
      state.simulacaoVencimento = value
    },
    simulacaoParcelas (state, { value, router }) {
      if (router) { value ? router.altPush('/simulacao?modal=parcelas') : router.altPush('/simulacao') }
      state.simulacaoParcelas = value
    },
    skipIntro (state, value) {
      state.skipIntro = value
    },
    searchCEP (state, { value, router }) {
      if (router) { value ? router.altPush('/endereco-cep?modal=cep') : router.altPush('/endereco-cep') }
      state.searchCEP = value
    },
    actualState (state, value) {
      state.actualState = value
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    enderecos (state) {
      return state.enderecos
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    },
    bottomSheetTermos (state) {
      return state.bottomSheetTermos
    },
    bottomSheetParcelas (state) {
      return state.bottomSheetParcelas
    },
    simulacaoVencimento (state) {
      return state.simulacaoVencimento
    },
    simulacaoParcelas (state) {
      return state.simulacaoParcelas
    },
    skipIntro (state) {
      return state.skipIntro
    },
    searchCEP (state) {
      return state.searchCEP
    },
    actualState (state) {
      return state.actualState
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        endereco: {}
      }
      commit('model', data)
    },
    beforeEach ({ getters, commit }, { to, from, next }) {
      var routeBack = !window.programmaticRouter && window.history.state && getters.actualState >= window.history.state.key
      window.programmaticRouter = false

      if (window.history.state) { commit('actualState', window.history.state.key) }

      if (routeBack) {
        switch (from.fullPath) {
          case '/apresentacao-1':
            to.fullPath !== '/home' && next({ path: '/home' })
            break;
          case '/apresentacao-2':
            to.fullPath !== '/apresentacao-1' && next({ path: '/apresentacao-1' })
            break;
          case '/apresentacao-3':
            to.fullPath !== '/apresentacao-2' && next({ path: '/apresentacao-2' })
            break;
          case '/limite-credito':
            if (getters.skipIntro === 1) {
              to.fullPath !== '/apresentacao-1' && next({ path: '/apresentacao-1' })
            } else if (getters.skipIntro === 2) {
              to.fullPath !== '/apresentacao-2' && next({ path: '/apresentacao-2' })
            } else if (getters.skipIntro === 3) {
              to.fullPath !== '/apresentacao-3' && next({ path: '/apresentacao-3' })
            }
            commit('skipIntro', 3)
            break;
          case '/credito-pessoal-objetivo':
            to.fullPath !== '/limite-credito' && next({ path: '/limite-credito' })
            break;
          case '/simulacao':
            to.fullPath !== '/credito-pessoal-objetivo' && next({ path: '/credito-pessoal-objetivo' })
            break;
          case '/detalhes-proposta':
            to.fullPath !== '/simulacao' && next({ path: '/simulacao' })
            break;
          case '/termos-e-condicoes-gerais':
          case '/bmp-money-plus':
            to.fullPath !== '/detalhes-proposta?bottom=parcelas' && next({ path: '/detalhes-proposta?bottom=parcelas' })
            break;
          case '/informacoes-basicas-cpf':
            to.fullPath !== '/detalhes-proposta' && next({ path: '/detalhes-proposta' })
            break;
          case '/cpf-erro':
            to.fullPath !== '/informacoes-basicas-cpf' && next({ path: '/informacoes-basicas-cpf' })
            break;
          case '/informacoes-contato-email':
            to.fullPath !== '/informacoes-basicas-cpf' && next({ path: '/informacoes-basicas-cpf' })
            break;
          case '/informacoes-contato-email-input':
            to.fullPath !== '/informacoes-contato-email' && next({ path: '/informacoes-contato-email' })
            break;
          case '/endereco-list':
            to.fullPath !== '/informacoes-contato-email' && next({ path: '/informacoes-contato-email' })
            break;
          case '/endereco-home':
            to.fullPath !== '/informacoes-contato-email' && next({ path: '/informacoes-contato-email' })
            break;
          case '/endereco-cep':
            if (getters.enderecos.length > 0) { to.fullPath !== '/endereco-list' && next({ path: '/endereco-list' }) } else { to.fullPath !== '/informacoes-contato-email' && next({ path: '/informacoes-contato-email' }) }
            break;
          case '/endereco-formulario':
            if (getters.enderecos.length > 0) { to.fullPath !== '/endereco-list' && next({ path: '/endereco-list' }) } else { to.fullPath !== '/endereco-cep' && next({ path: '/endereco-cep' }) }
            break;
          case '/validacao-documento':
            to.fullPath !== '/endereco-formulario' && next({ path: '/endereco-formulario' })
            break;
          case '/analise-proposta-1':
          case '/analise-proposta-2':
          case '/analise-proposta-3':
          case '/analise-proposta-4':
          case '/consulta-contrato':
          case '/comprovante':
            to.fullPath !== '/home' && next({ path: '/home' })
            break;
        }
      }

      switch (to.fullPath) {
        case '/simulacao':
          commit('simulacaoVencimento', { value: false })
          commit('simulacaoParcelas', { value: false })
          break;
        case '/endereco-cep':
          commit('searchCEP', { value: false })
          break;
        case '/simulacao?modal=vencimento':
          if (getters.simulacaoVencimento !== true) { commit('simulacaoVencimento', { value: true }) }
          break;
        case '/simulacao?modal=parcelas':
          if (getters.simulacaoParcelas !== true) { commit('simulacaoParcelas', { value: true }) }
          break;
        case '/detalhes-proposta':
          commit('bottomSheetTermos', { value: false })
          commit('bottomSheetParcelas', { value: false })
          break;
        case '/detalhes-proposta?bottom=termos':
          if (getters.bottomSheetTermos !== true && from.fullPath === '/detalhes-proposta') { commit('bottomSheetTermos', { value: true }) }
          break;
        case '/detalhes-proposta?bottom=parcelas':
          if (getters.bottomSheetParcelas !== true && from.fullPath === '/detalhes-proposta') { commit('bottomSheetParcelas', { value: true }) }
          break;
        case '/endereco-cep?modal=cep':
          if (getters.searchCEP !== true) { commit('searchCEP', { value: true }) }
          break;
      }
    }
  }
}]
